export default {
  listTitle: 'Components',
  resizePanel: 'Resize components panel',
  maximizePanel: 'Maximize components panel',
  minimizePanel: 'Restore components panel size',
};
